import React, { useCallback } from 'react';

import { ClassName, GADataType, I18nText, IsDisabled } from '../../types';

import { Translate } from '../Translate';

export interface RadioButtonInputProps<ValueType> {
  disabled?: IsDisabled;
  text?: string;
  i18nText?: I18nText;
  i18nDescription?: I18nText;
  descriptionClassName?: ClassName;
  labelClassName?: ClassName;
  name: string;
  onChange: (buttonValue: ValueType) => void;
  option: ValueType;
  optionClassName?: ClassName;
  value: ValueType;
  wrapperClassName?: ClassName;
}

function RadioButtonInput<ValueType extends string | number>({
  dataGa,
  descriptionClassName,
  disabled,
  i18nDescription,
  i18nText,
  labelClassName,
  name,
  onChange,
  option,
  optionClassName,
  text,
  value,
  wrapperClassName
}: RadioButtonInputProps<ValueType> & GADataType) {
  const handleChange = useCallback(() => {
    onChange(option);
  }, [option, onChange]);

  return (
    <div className={wrapperClassName || 'mr-4'}>
      <label className={labelClassName || 'inline-flex items-center'}>
        <input
          checked={value === option}
          className="basic-radio"
          data-ga={dataGa}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          type="radio"
          value={option}
        />

        <div>
          {i18nText || text ? (
            <span className={optionClassName || 'ml-2'}>
              {i18nText ? <Translate id={i18nText} /> : text}
            </span>
          ) : (
            <span className={optionClassName}>{option}</span>
          )}

          {i18nDescription && (
            <div className={descriptionClassName}>
              <Translate id={i18nDescription} />
            </div>
          )}
        </div>
      </label>
    </div>
  );
}

export default RadioButtonInput;
